import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getActebiCategory, getSubCategory } from '../../service/service';
import { motion } from 'framer-motion';
import SakrebuloActs from '../SakrebuloActs';
import SakrebuloList from '../SakrebuloList';
import { SearchContext } from '.././Contexts/Context';
import ActebiFilters from './ActebiFilters';
import ActebiList from './ActebiList';

export default function SakrebulosActebi() {
	const { language } = useContext(SearchContext);
	const ref = useRef(null);
	const [width, setWidth] = useState(10);
	const { slug } = useParams();
	const [category, setCategory] = useState([]);
	const [filter, setFilter] = useState([]);

	useEffect(() => {
		const getSub = async () => {
			const data = await getActebiCategory();
			setCategory(data);
		};
		getSub();
	}, []);

	useEffect(() => {
		if (slug && category.length > 0) {
			const filterCategory = category.filter(item => item.slug === slug);
			setFilter(filterCategory[0]);
		}
	}, [slug, category]);

	useEffect(() => {
		const getSub = async () => {
			await getActebiCategory().then(data => {
				setCategory(data);
			});
		};
		getSub();
	}, []);
	return (
		<motion.div
			intial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<div className='news-container margin-280px defaultSkhdoma'>
				<header>
					<span className='big' ref={ref} style={{ marginRight: width / 2 }}>
						{language === 1 ? 'სამართლებრივი აქტები' : 'LEGAL ACTS'}
					</span>

					<span>{filter?.title}</span>
				</header>
				<div>
					<div className='sakrebulo-landing'>
						<div className='landing-container'>
							<div className='sajaroInfo '>
								<ActebiFilters />
								{/* <SakrebuloActs actsSlug={filter?.slug} /> */}
							</div>
						</div>
					</div>
					<div className='presscenter-info'>
						<ActebiList />
					</div>
				</div>
			</div>
		</motion.div>
	);
}
